var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#1f1f1f",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M281.54-160q-8.5 0-14.25-5.75T261.54-180v-75.85Q242-264.31 221-291.88q-21-27.58-21-63.5V-720q0-62.25 67.37-91.13Q334.74-840 479.97-840q150.49 0 215.26 27.75Q760-784.5 760-720v364.62q0 35.92-21 63.5-21 27.57-40.54 36.03V-180q0 8.5-5.75 14.25T678.46-160h-9.23q-8.5 0-14.25-5.75T649.23-180v-60H310.77v60q0 8.5-5.75 14.25T290.77-160h-9.23Zm198.92-578.46h236.31-472.62 236.31ZM640-480H240h480-80Zm-400-40h480v-178.46H240V-520Zm131.73 171.55q12.89-13.07 12.89-31.73 0-18.67-13.07-31.55-13.07-12.89-31.73-12.89-18.67 0-31.55 13.07-12.89 13.07-12.89 31.73 0 18.67 13.07 31.55 13.07 12.89 31.73 12.89 18.67 0 31.55-13.07Zm280 0q12.89-13.07 12.89-31.73 0-18.67-13.07-31.55-13.07-12.89-31.73-12.89-18.67 0-31.55 13.07-12.89 13.07-12.89 31.73 0 18.67 13.07 31.55 13.07 12.89 31.73 12.89 18.67 0 31.55-13.07ZM244.15-738.46h472.62q-10.39-30.85-64.12-46.19Q598.92-800 480.46-800q-117.77 0-171.5 15.58-53.73 15.57-64.81 45.96ZM320-280h320q33 0 56.5-23.5T720-360v-120H240v120q0 33 23.5 56.5T320-280Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBus);
export default __webpack_public_path__ + "static/media/bus.c2c0a8657ccb4d88295eafe543369293.svg";
export { ForwardRef as ReactComponent };